(function () {
  var currency = (window.Shopify && window.Shopify.currency) || { active: 'GBP', rate: '1.0' };
  var rate = parseFloat(currency.rate) || 1;
  var locale = document.documentElement.lang || 'en';

  function formatMoney(gbpAmount) {
    var converted = gbpAmount * rate;
    var decimals = converted >= 100 ? 0 : 2;
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency.active,
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(converted);
    } catch (e) {
      return currency.active + ' ' + converted.toFixed(decimals);
    }
  }

  function convertPrices(root) {
    var els = (root || document).querySelectorAll('[data-sv-gbp]');
    for (var i = 0; i < els.length; i++) {
      var value = parseFloat(els[i].getAttribute('data-sv-gbp'));
      if (!isNaN(value)) {
        els[i].textContent = formatMoney(value);
      }
    }
  }

  function initCalculators() {
    var calcs = document.querySelectorAll('[data-sv-calc]');
    for (var i = 0; i < calcs.length; i++) {
      (function (calc) {
        if (calc.hasAttribute('data-sv-ready')) return;
        calc.setAttribute('data-sv-ready', 'true');
        var buy = parseFloat(calc.getAttribute('data-buy')) || 0;
        var sell = parseFloat(calc.getAttribute('data-sell')) || 0;
        var each = Math.max(0, sell - buy);
        var slider = calc.querySelector('[data-sv-calc-units]');
        var unitsOut = calc.querySelector('[data-sv-calc-units-out]');
        var profitOut = calc.querySelector('[data-sv-calc-profit]');
        var eachOut = calc.querySelector('[data-sv-calc-each]');
        if (!slider) return;
        function update() {
          var units = parseInt(slider.value, 10) || 0;
          if (unitsOut) unitsOut.textContent = units;
          if (profitOut) profitOut.textContent = formatMoney(each * units);
          if (eachOut) eachOut.textContent = formatMoney(each);
        }
        slider.addEventListener('input', update);
        update();
      })(calcs[i]);
    }
  }

  function initAddonForms() {
    var forms = document.querySelectorAll('[data-sv-buy-form]');
    for (var i = 0; i < forms.length; i++) {
      (function (form) {
        if (form.hasAttribute('data-sv-ready')) return;
        form.setAttribute('data-sv-ready', 'true');
        form.addEventListener('submit', function (event) {
          var addon = document.querySelector('[data-sv-addon]');
          if (!addon || !addon.checked) return;
          event.preventDefault();
          var mainId = form.querySelector('input[name="id"]').value;
          var button = form.querySelector('[type="submit"]');
          if (button) button.setAttribute('disabled', 'disabled');
          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [
                { id: parseInt(mainId, 10), quantity: 1 },
                { id: parseInt(addon.value, 10), quantity: 1 }
              ]
            })
          })
            .then(function (response) {
              if (!response.ok) throw new Error('Cart error');
              window.location.href = root + 'checkout';
            })
            .catch(function () {
              if (button) button.removeAttribute('disabled');
              form.submit();
            });
        });
      })(forms[i]);
    }
  }

  function init() {
    convertPrices();
    initCalculators();
    initAddonForms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
